module.exports = __webpack_public_path__ + "media/media/about/support-558ff210572a2f72ac92cc4ba4ea28e5.png";